<template>
  <el-row type="flex" class="app-layout orver-hidden-x slow-system-call-list">
    <el-form
      class="padding-20"
      :style="{
        'border-bottom': '1px solid #e5e5e5',
        'text-align': 'left',
      }"
      ref="queryForm"
      :model="formQuery"
      size="small"
      @submit="searchTableData(1)"
      inline
      @keyup.enter.native="searchTableData(1)"
    >
        <el-form-item label prop="serverName" label-width="0">
          <el-input
            v-model.trim="formQuery.serverName"
            placeholder="请输入服务名称"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label prop="uriPathPattern" label-width="0">
          <el-input
            v-model.trim="formQuery.uriPathPattern"
            placeholder="请输入接口地址"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item>
            <el-button
            icon="el-icon-search"
            type="primary"
            :loading="tableLoading"
            size="small"
            @click="searchTableData(1)"
          >查询</el-button>
        </el-form-item>

        <el-form-item :style="{'float': 'right'}">
           <el-button size="small" :loading="tableLoading" @click="queryReset(1)">重置</el-button>
          <column-switch
            class="margin-left-10"
            name="SYSTEM_SLOW_CALL_LIST"
            :columns.sync="columns"
          >
            <el-button size="small" type="primary">列设置</el-button>
          </column-switch>
        </el-form-item>

    </el-form>
    <div class="flex-table">
      <el-table
        height="100%"
        :key="columns.length"
        :data="tableData"
        v-loading="tableLoading"
        stripe
        style="width: 100%"
      >
        <template v-for="(item, index) in columnsList">
          <el-table-column
            v-if="columns[item.label]"
            :width="item.width"
            :min-width="item.minWidth"
            :label="item.label"
            :prop="item.prop"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-row class="padding-20">
      <el-col align="right">
        <el-pagination
          class="analyze-users-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="formQuery.pageNum"
          :page-sizes="[20, 50, 100, 200, 300, 400]"
          :page-size.sync="formQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="formQuery.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { queryApiStatistics } from '@/api/tracking';

export default {
  name: 'TrackingSlowSystemCallList',
  data() {
    return {
      formQuery: {
        serverName: '',
        uriPathPattern: '',
        pageNum: 1,
        pageSize: 20,
      },
      tableLoading: false,
      tableData: [],
      columnsList: [
        {
          label: '服务名称',
          minWidth: 160,
          prop: 'serverName',
        },
        {
          label: '接口地址',
          prop: 'uriPathPattern',
          minWidth: 160,
        },
        {
          label: '请求方法',
          prop: 'httpMethod',
        },
        {
          label: '前1天访问次数',
          prop: 'last1dayCount',
        },
        {
          label: '前7天访问次数',
          prop: 'last7dayCount',
        },
        {
          label: '前30天访问次数',
          prop: 'last30dayCount',
        },
        {
          label: '前180天访问次数',
          prop: 'last180dayCount',
        },
      ],
      columns: {
        服务名称: true,
        接口地址: true,
        请求方法: true,
        前1天访问次数: true,
        前7天访问次数: true,
        前30天访问次数: true,
        前180天访问次数: true,
      },
    };
  },
  mounted() {
    this.searchTableData();
  },
  methods: {
    // 重置方法
    queryReset() {
      Object.assign(this.$data, this.$options.data());
      this.searchTableData(1);
    },
    async searchTableData(currentPageNum) {
      try {
        this.tableLoading = true;
        const {
          pageNum,
          pageSize,
          serverName,
          uriPathPattern,
        } = this.formQuery;

        const params = {
          serverName,
          uriPathPattern,
          pageNum: currentPageNum || pageNum,
          pageSize,
        };

        const {
          data: { list, total },
        } = await queryApiStatistics(params);
        this.formQuery.total = total;
        this.tableData.splice(0, this.tableData.length, ...list);
      } finally {
        this.tableLoading = false;
      }
    },
    handleSizeChange(size) {
      this.formQuery.pageSize = size;
      this.formQuery.pageNum = 1;
      this.searchTableData();
    },
    handleCurrentChange(num) {
      this.formQuery.pageNum = num;
      this.searchTableData();
    },
  },
};
</script>
<style lang="scss">
.el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {
  display: none;
}
</style>
<style lang="scss" scoped>
.app-layout {
  height: calc(100vh - 100px);
  flex-direction: column;
  .flex-table {
    flex: 1;
  }
}
</style>
